<template>
  <div>
    <filter-bar
      name="reconciliation"
      :filter="
        tab === 0
          ? getReconciliationFilter.return
          : getReconciliationFilter.oneWay
      "
      v-if="!showMobileView"
      :searchTypes="
        tab === 0
          ? ['Tablet']
          : ['Contact', 'Tablets', 'Stores', 'Destinations']
      "
    />
    <div class="d-flex pt-3" style="height:70px;" v-if="!showMobileView">
      <v-tabs
        centered
        class="mt-4 text-capitalize"
        color="black"
        v-if="!showMobileView"
        height="28px"
        v-model="tab"
      >
        <v-tab id="return-tab">Return</v-tab>
        <v-tab id="one-way-tab">One-Way Portal</v-tab>
      </v-tabs>
      <div class="d-flex align-end">
        <v-card
          class="mr-4 mt-4 mb-1 d-flex align-center"
          height="48"
          width="148"
          color="secondary"
          v-if="!showMobileView"
          style="color:white; font-weight:bold; position:absolute; right:0;"
          @click="setDataExport(true)"
        >
          <v-row>
            <v-spacer />
            <v-spacer />
            <v-row class="d-flex justify-space-around" id="export-report">
              <v-icon color="white">mdi-download</v-icon>
              Export Report
            </v-row>
            <v-spacer />
            <v-spacer />
          </v-row>
        </v-card>
      </div>
    </div>
    <v-tabs
      centered
      class="mt-6 text-capitalize"
      color="black"
      v-if="showMobileView"
      height="28px"
      v-model="tab"
    >
      <v-tab>Return</v-tab>
      <v-tab>One-Way Portal</v-tab>
    </v-tabs>
    <v-tabs-items style="background: #EFEFEF" v-model="tab">
      <v-tab-item>
        <v-row class="d-flex justify-end">
          <v-card
            class="mr-4 mt-4 d-flex align-center"
            height="48"
            width="48"
            v-if="showMobileView"
            color="black"
            @click="_setFilter(true)"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-icon color="white">mdi-filter</v-icon>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card>
          <v-card
            class="mr-7 mt-4 d-flex align-center"
            height="48"
            width="48"
            v-if="showMobileView"
            color="black"
            @click="setDataExport(true)"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-icon color="white">mdi-download</v-icon>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card>
        </v-row>
        <div :class="componentClass">
          <overdue-chart />
          <report />
        </div>
        <report-table />
        <history />
      </v-tab-item>
      <v-tab-item>
        <v-row class="d-flex justify-end">
          <v-card
            class="mr-4 mt-4 d-flex align-center"
            height="48"
            width="48"
            v-if="showMobileView"
            color="black"
            @click="_setFilter(true)"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-icon color="white">mdi-filter</v-icon>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card>
          <v-card
            class="mr-7 mt-4 d-flex align-center"
            height="48"
            width="48"
            color="secondary"
            v-if="showMobileView"
            @click="setDownload()"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-icon color="white">mdi-download</v-icon>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card>
        </v-row>
        <call-status-chart />
        <one-way-table />
      </v-tab-item>
    </v-tabs-items>
    <filters />
    <report-export />
    <export-modal />
    <export-confirmation />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import OverdueChart from '@/components/reconciliation/OverdueChart';
import Report from '@/components/reconciliation/Report';
import Filters from '@/components/filter/Filters';
import ReportTable from '@/components/reconciliation/ReportTable';
import OneWayTable from '@/components/reconciliation/OneWayTable';
import History from '@/components/reconciliation/History';
import CallStatusChart from '@/components/reconciliation/CallStatusChart';
import ReportExport from '@/components/reconciliation/ReportExport';
import ExportModal from '@/components/reconciliation/ExportModal';
import ExportConfirmation from '@/components/reconciliation/ExportConfirmation';
import FilterBar from '@/components/app/FilterBar.vue';
import { MobileView } from '@/mixins';

export default {
  components: {
    OverdueChart,
    ReportTable,
    OneWayTable,
    History,
    Filters,
    CallStatusChart,
    Report,
    ReportExport,
    FilterBar,
    ExportModal,
    ExportConfirmation,
  },
  mixins: [MobileView],
  data: () => ({
    reconHeaders: ['recon'],
  }),
  methods: {
    ...mapMutations({
      _setFilter: 'filters/setFilters',
      _setTab: 'reconciliation/setTab',
      setReconciliationFilter: 'filters/setReconciliationFilter',
      setDataExport: 'reconciliation/setExport',
    }),
    ...mapActions({
      _getRentalData: 'reconciliation/acquireRentalData',
      _getOneWayData: 'reconciliation/acquireOneWayData',
    }),
    setDownload() {

    },
  },
  computed: {
    ...mapGetters({
      _filters: 'filters/getFilters',
      _queryParams: 'reconciliation/getQueryParams',
      _getTab: 'reconciliation/getTab',
      getReconciliationFilter: 'filters/getFilter',
      userGroups: 'account/getUserGroups',
    }),
    tab: {
      get() {
        return this._getTab;
      },
      set(val) {
        this._setTab(val);
      },
    },
    componentClass() {
      if (!this.showMobileView) {
        return 'd-flex flex-row';
      }
      return 'd-flex flex-column';
    },
  },
  mounted() {
    if (this._queryParams && this.userGroups) {
      this._getRentalData();
      this._getOneWayData();
    }
  },
  watch: {
    _queryParams: {
      handler() {
        this._getRentalData();
        this._getOneWayData();
      },
      deep: true,
    },
    userGroups: {
      handler() {
        this._getRentalData();
        this._getOneWayData();
      },
      deep: true,
    },
  },
};
</script>
